var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "video" },
    [
      _c("div", { staticClass: "remote", attrs: { id: "remote" } }),
      _vm._v(" "),
      _c("canvas", {
        directives: [
          { name: "show", rawName: "v-show", value: false, expression: "false" }
        ],
        attrs: { id: "canvas" }
      }),
      _vm._v(" "),
      _c(
        "BloomDialog",
        {
          staticStyle: { "z-index": "99999" },
          attrs: {
            show: _vm.browserVideoVisible,
            closeOnClickModal: false,
            hasCloseIcon: false,
            width: "400",
            top: "300px"
          },
          on: {
            "update:show": function($event) {
              _vm.browserVideoVisible = $event
            },
            close: _vm.closeChrome
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: { "font-size": "16px", "word-break": "break-word" }
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("bloomTest00121")) + "\n    ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn-video-dialog cursor",
              on: { click: _vm.closeChrome }
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("bloomTest00018")) + "\n    ")]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "BloomDialog",
        {
          staticStyle: { "z-index": "99999" },
          attrs: {
            show: _vm.openVideoVisible,
            closeOnClickModal: false,
            hasCloseIcon: false,
            width: "600",
            top: "150px"
          },
          on: {
            "update:show": function($event) {
              _vm.openVideoVisible = $event
            },
            close: _vm.closeChrome
          }
        },
        [
          _c("div", { staticClass: "el-dialog__header title bold" }, [
            _vm._v(_vm._s(_vm.$t("bloomTest00131")))
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog__body",
              staticStyle: { "font-size": "16px", "word-break": "break-word" }
            },
            [
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      _vm.microphone == 0 ? "bloomTest00149" : "bloomTest00150"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _c("img", {
                staticClass: "cmImg",
                attrs: {
                  src: _vm.$t(
                    _vm.microphone == 0 ? "bloomTest00151" : "bloomTest00152"
                  ),
                  alt: "",
                  srcset: ""
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer cancelBtn cursor",
              on: {
                click: function($event) {
                  _vm.openVideoVisible = false
                }
              }
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("bloomTest00133")) + "\n    ")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-466ef6e5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-466ef6e5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/public/video.vue
// module id = null
// module chunks = 